import { ASSET } from "@/lib/api";



/** Admin-uploaded media stored in MongoDB. */

export function isMediaPath(path) {

  if (!path) return false;

  return path.includes("/api/media/");

}



/** External absolute URLs only — no variant pipeline. */

export function isDirectImagePath(path) {

  if (!path) return false;

  if (path.startsWith("http://") || path.startsWith("https://")) return true;

  return false;

}



export function mediaIdFromPath(path) {

  if (!isMediaPath(path)) return "";

  const tail = path.split("/api/media/").pop().split("?")[0].split("#")[0];

  return tail.split("/")[0];

}



export function mediaImageSrc(path, size = "sm", format = "webp") {

  const id = mediaIdFromPath(path);

  if (!id) return "";

  const ext = format === "jpg" || format === "jpeg" ? "jpg" : "webp";

  return ASSET(`/api/media/${id}/${size}.${ext}`);

}



/** Build optimized variant URL from catalog path e.g. .../foo.jpg -> .../foo-sm.webp */

export function productImageVariant(path, size = "sm", ext = "webp") {

  if (!path || isDirectImagePath(path) || isMediaPath(path)) return path || "";

  const normalized = path.replace(/(\.[^./]+)$/, "");

  return `${normalized}-${size}.${ext}`;

}



export function productImageSrc(path, variant = "sm", ext = "webp") {

  if (!path) return "";

  const size = variant === "md" ? "md" : variant === "xs" ? "xs" : "sm";

  if (isMediaPath(path)) return mediaImageSrc(path, size, ext);

  return ASSET(productImageVariant(path, size, ext));

}



export function productImageSrcSet(path, ext = "webp") {

  if (!path || isDirectImagePath(path)) return undefined;

  if (isMediaPath(path)) {

    return [

      `${mediaImageSrc(path, "xs", ext)} 320w`,

      `${mediaImageSrc(path, "sm", ext)} 520w`,

      `${mediaImageSrc(path, "md", ext)} 720w`,

    ].join(", ");

  }

  if (!path.includes(".")) return undefined;

  return [

    `${productImageSrc(path, "xs", ext)} 320w`,

    `${productImageSrc(path, "sm", ext)} 520w`,

    `${productImageSrc(path, "md", ext)} 720w`,

  ].join(", ");

}



export function productImageJpgFallback(path) {

  if (isMediaPath(path)) return mediaImageSrc(path, "sm", "jpg");

  if (isDirectImagePath(path)) return ASSET(path);

  return ASSET(productImageVariant(path, "sm", "jpg"));

}



/** Full-size lightbox source (md WebP). */

export function productImageLightboxSrc(path) {

  if (!path) return "";

  if (isDirectImagePath(path)) return ASSET(path);

  return productImageSrc(path, "md");

}



export function productImageLightboxFallback(path) {

  if (!path) return "";

  if (isMediaPath(path)) return mediaImageSrc(path, "md", "jpg");

  if (isDirectImagePath(path)) return ASSET(path);

  return ASSET(productImageVariant(path, "md", "jpg"));

}



export const PRODUCT_IMAGE_SIZES =

  "(max-width: 480px) 45vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 280px";



export const HERO_IMAGE_SIZES = "(max-width: 768px) 100vw, 50vw";



export const THUMB_IMAGE_SIZES = "80px";



const prefetched = new Set();



/** Warm the browser image cache for catalog paths (deduped). */

export function prefetchProductImage(path, variant = "sm") {

  if (!path || isDirectImagePath(path)) return;

  const url = productImageSrc(path, variant);

  if (!url || prefetched.has(url)) return;

  prefetched.add(url);

  const img = new Image();

  img.decoding = "async";

  img.src = url;

}



export function prefetchProductImages(products, { limit = 16, variant = "sm" } = {}) {

  if (!Array.isArray(products)) return;

  products.slice(0, limit).forEach((p) => {

    if (p?.image) prefetchProductImage(p.image, variant);

  });

}


